import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.34 7.717a.737.737 0 0 1 0 1.06 1 1 0 0 1-.11.1l-5.59 5.59a.7.7 0 0 1-.5.22l-3.22.11h-.08a.5.5 0 0 1-.12-.02.487.487 0 0 1-.11-.04.449.449 0 0 1-.12-.06 1.063 1.063 0 0 1-.11-.09.524.524 0 0 1-.1-.11.707.707 0 0 1-.11-.25.675.675 0 0 1-.02-.14v-.06l.1-3.22a.767.767 0 0 1 .22-.5l5.7-5.7a.754.754 0 0 1 1.06 0Zm2.68-5.79a3.029 3.029 0 0 0-4.27.1l-.48.48a.737.737 0 0 0 0 1.06l3.1 3.11a.742.742 0 0 0 .53.22.71.71 0 0 0 .53-.22l.49-.48a3.127 3.127 0 0 0 .93-2.22 2.83 2.83 0 0 0-.83-2.05Z';
const draw24px =
  'M20,9l-.63.63a.75.75,0,0,1-1.06,0l-4-4a.75.75,0,0,1,0-1.06l.63-.63a3.91,3.91,0,0,1,2.74-1.15,3.45,3.45,0,0,1,2.49,1A3.7,3.7,0,0,1,20,9ZM11.94,7.09a.76.76,0,0,0-.38.21A1,1,0,0,1,11.94,7.09Zm.29,0a.88.88,0,0,1,.39.21A.79.79,0,0,0,12.23,7.09Zm4.43,4.25-4-4a.88.88,0,0,0-.39-.21h-.29a1,1,0,0,0-.38.21L4.14,14.71a.75.75,0,0,0-.22.51L3.79,19.4v.08a.43.43,0,0,0,0,.11.36.36,0,0,0,.07.17.41.41,0,0,0,.05.09.77.77,0,0,0,.18.18l.09,0a.51.51,0,0,0,.17.07l.13,0h.06L8.75,20a.74.74,0,0,0,.5-.22l7.41-7.41A.75.75,0,0,0,16.66,11.34Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PencilFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'pencilFilled'),
) as IconWithRender;

PencilFilledIcon.displayName = 'PencilFilledIcon';
PencilFilledIcon.propTypes = Icon.propTypes;
PencilFilledIcon.renderIcon = (props) => <PencilFilledIcon {...props} />;
export default PencilFilledIcon;
